// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ik-image-tag[data-v-c26e2b20] {\n  cursor: pointer;\n  overflow: visible;\n}", ""]);
// Exports
module.exports = exports;
